import NotaFiscalEntradaModel from "../models/notaFiscalEntradaModel";
import NotaFiscalEletronicaImportacaoQuestionMessageViewModel from "../models/questionMessages/notaFiscalEletronicaImportacaoQuestionMessageViewModel";
import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

export default class NotaFiscalEntradaService extends IService<NotaFiscalEntradaModel> {
    constructor() {
        super("NotaFiscalEntrada");
    }

    public override insert(data: NotaFiscalEntradaModel): Promise<Response> {
        return nfetch(`/${this.controllerName}/Insert`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify({ data }),
        });
    }

    public getList(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        dataInicial?: string,
        dataFinal?: string,
    ): Promise<Response> {
        const encodedFilter = encodeURIComponent(filterKey);
        return nfetch(
            `/${this.controllerName}/List?filterKey=${encodedFilter}&sortKey=${sortKey}&sortOrder=${sortOrder}&pageIndex=${pageIndex}&pageSize=${pageSize}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public insertWithQuestions(
        data: NotaFiscalEntradaModel,
        questionMessages: NotaFiscalEletronicaImportacaoQuestionMessageViewModel[],
    ): Promise<Response> {
        return nfetch(`/${this.controllerName}/Insert`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify({ data, questionMessages }),
        });
    }

    public validate(model: NotaFiscalEntradaModel): Promise<Response> {
        return nfetch(`/${this.controllerName}/Validate`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify(model),
        });
    }

    public validateImportacaoNotaFiscal(model: object): Promise<Response> {
        return nfetch(`/${this.controllerName}/ValidateImportacaoNotaFiscal`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify(model),
        });
    }

    public getByProdutoId(produtoLoteId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByProdutoLote?produtoLoteId=${produtoLoteId}`, {
            method: "get",
            credentials: "same-origin",
            headers: {
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
        });
    }

    public getByProduto(produtoId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByProduto?produtoId=${produtoId}`, {
            method: "get",
            credentials: "same-origin",
        });
    }
}
